import { useTranslation } from "@i18n";
import React, { useState } from "react";
import IconComponent from "@CubeComponents/icons";
import useModulesMapper from "@Components/StickySidebarViewer/ModulesMapper";

import Accordion from "@CubeComponents/html/accordion/materialUiAccordian/index";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

function DesignViewerLayoutSettingComponent(props: any) {
  const { t } = useTranslation();
  const [selectedData, setSelectedData] = useState<any>(null);
  const [onPositionAccordion, setOnPositionAccordion] = useState<any>(null);
  const [dragging, setDragging] = useState<any>(null);
  const [selectedAccordion, setSelectedAccordion] = useState<any[]>([]);
  const [modulesMapper] = useModulesMapper(props);

  function onDragOver1(e: React.DragEvent<HTMLElement>) {
    e.preventDefault();
  }
  function onDragOver2(e: React.DragEvent<HTMLElement>) {
    e.preventDefault();
  }
  function availableContent(itemArray: any, accordionName: any, index: any) {
    return itemArray
      .filter((data) => modulesMapper[data])
      .map((data: any) => (
        <div
          key={index}
          className={
            selectedAccordion.includes(index)
              ? "flex flex-row items-center gap-3.5 py-4 ps-6 text-sm"
              : "flex flex-row items-center gap-3.5 py-4 ps-6 text-sm bg-[var(--surface-white)]"
          }
          draggable
          {...({ droppable: "true" } as any)}
          onDragStart={(e) =>
            dragStartInsideAvailable(e, {
              accordionName,
              itemArray: [data],
              index,
            })
          }
        >
          <IconComponent name={`SidebarIcon/${modulesMapper[data].name}`} height="1.25rem" width="1.25rem" />
          <div>{modulesMapper[data].name}</div>
        </div>
      ));
  }

  function addedContent(itemArray: any, accordionName: any, index: any) {
    return itemArray
      .filter((data) => modulesMapper[data])
      .map((data: any) => (
        <div
          key={index}
          className="flex flex-row items-center gap-3.5 py-4 ps-6 text-sm bg-[var(--surface-white)]"
          draggable
          onDragStart={(e) => dragStartInsideAdded(e, { accordionName, itemArray: [data], index })}
        >
          <IconComponent name={`SidebarIcon/${modulesMapper[data].name}`} height="1.25rem" width="1.25rem" />
          <div>{modulesMapper[data].name}</div>
        </div>
      ));
  }
  function headerAvailable(accordionName: any) {
    return <div className="text-sm font-semibold py-1">{accordionName}</div>;
  }
  function headerAdded(accordionName: any) {
    return <div className="text-sm font-semibold py-1">{accordionName}</div>;
  }

  // -------------------------------dragStart---------------------------

  function dragStartAvailable(e: any, itemsData: any) {
    setSelectedData(itemsData);
    setDragging(1);
  }
  function dragStartAdded(e: any, itemsData: any) {
    setSelectedData(itemsData);
    setDragging(2);
  }

  // -------------------------------dragStartInside-----------------------

  function dragStartInsideAvailable(e: React.DragEvent<HTMLElement>, itemsData: any) {
    setSelectedData(itemsData);
    setDragging(1);
    e.stopPropagation();
  }
  function dragStartInsideAdded(e: React.DragEvent<HTMLElement>, itemsData: any) {
    setSelectedData(itemsData);
    setDragging(2);
    e.stopPropagation();
  }

  // ---------------------------------onDrop-----------------------------
  function onDropAvailable() {
    if (dragging == 1) {
      if (onPositionAccordion == null) {
        return;
      }
      if (
        selectedData.itemArray.length !=
        props.availableData[selectedData.index][selectedData.accordionName].widgets.length
      ) {
        return;
      }
      const dataAvailable = selfArrangeAccordion(props.availableData);
      props.setAvailableData(dataAvailable);
      return;
    }
    if (selectedData == null) {
      return;
    }
    // ADD
    const selectedDataItemArray = [...selectedData.itemArray];
    const dataAvailable = addToOtherSide(props.availableData, selectedDataItemArray);
    props.setAvailableData(dataAvailable);
    // REMOVE
    const dataAdded = removeFromCurrentSide(props.addedData, selectedDataItemArray);
    props.setAddedData(dataAdded);
  }

  function onDropAdded() {
    if (dragging == 2) {
      if (onPositionAccordion == null) {
        return;
      }
      if (
        selectedData.itemArray.length != props.addedData[selectedData.index][selectedData.accordionName].widgets.length
      ) {
        return;
      }
      const dataAdded = selfArrangeAccordion(props.addedData);
      props.setAddedData(dataAdded);
      return;
    }
    if (selectedData == null) {
      return;
    }
    // ADD
    const selectedDataItemArray = [...selectedData.itemArray];
    const dataAdded = addToOtherSide(props.addedData, selectedDataItemArray);
    props.setAddedData(dataAdded);
    // REMOVE
    const dataAvailable = removeFromCurrentSide(props.availableData, selectedDataItemArray);
    props.setAvailableData(dataAvailable);
  }

  function selfArrangeAccordion(items: any) {
    const data = [...items];
    const fromIndex = selectedData.index;
    const toIndex = onPositionAccordion;
    const element = data.splice(fromIndex, 1)[0];
    data.splice(toIndex, 0, element);
    setOnPositionAccordion(null);
    return data;
  }

  function addToOtherSide(item: any, selectedDataItemArray: any) {
    const data = [...item];
    let found = false;
    data.map((object: any) => {
      if (Object.keys(object)[0] == selectedData.accordionName) {
        object[selectedData.accordionName].widgets.push(...selectedDataItemArray);
        found = true;
      }
    });
    if (!found) {
      if (onPositionAccordion != null) {
        data.splice(onPositionAccordion, 0, {
          [selectedData.accordionName]: { widgets: [...selectedDataItemArray] },
        });
        setOnPositionAccordion(null);
      } else {
        data.push({
          [selectedData.accordionName]: { widgets: [...selectedDataItemArray] },
        });
      }
    }
    return data;
  }

  function removeFromCurrentSide(item: any, selectedDataItemArray: any) {
    const data = [...item];
    selectedDataItemArray.map((item: any) => {
      const indexOfItem = data[selectedData.index][selectedData.accordionName].widgets.indexOf(item);
      data[selectedData.index][selectedData.accordionName].widgets.splice(indexOfItem, 1);
    });
    if (data[selectedData.index][selectedData.accordionName].widgets.length == 0) {
      data.splice(selectedData.index, 1);
    }
    return data;
  }

  // ---------------------onDragEnter--------------------------------------

  function onDragEnterAvailable(index: any) {
    setOnPositionAccordion(index);
  }
  function onDragEnterAdded(index: any) {
    setOnPositionAccordion(index);
  }

  // -----------------------onDragEnd---------------------------------------
  function onDragEndAvailable() {
    setSelectedData(null);
    setOnPositionAccordion(null);
    setDragging(null);
  }
  function onDragEndAdded() {
    setSelectedData(null);
    setOnPositionAccordion(null);
    setDragging(null);
  }
  // /////////////////////////////////////
  // function onDragLeave() {
  //   console.log('leave');
  // }
  // /////////////////////////////////////
  function onClickAccordion(e: React.MouseEvent<HTMLElement>) {
    const index = e.currentTarget.attributes["data-index"].value;
    const selectedaccordion = selectedAccordion;
    selectedaccordion.push(index);
    setSelectedAccordion(selectedaccordion);
  }

  return (
    <div className="flex justify-between px-10 gap-[4%] text-[var(--primary-text)] text-sm font-semibold w-full overflow-hidden pb-5 h-full">
      <div className="w-full h-full pt-7 flex flex-col gap-7">
        <div>{t("Available")}</div>
        <div
          className="border-px border-[var(--surface-stroke-gradient-color1)] shadow-[0.25rem_0.25rem_0.9375rem_rgb(65_92_171_/_15%)] rounded-lg overflow-auto h-full px-4"
          {...({ droppable: "true" } as any)}
          onDragOver={onDragOver1}
          onDrop={() => onDropAvailable()}
          onDragEnd={onDragEndAvailable}
        >
          {props.availableData.map((object: any, index: number) => {
            const accordionName: any = Object.keys(object)[0];
            return (
              <div
                key={index}
                data-index={index}
                onClick={onClickAccordion}
                draggable
                onDragStart={(e) =>
                  dragStartAvailable(e, {
                    accordionName,
                    itemArray: object[accordionName]?.widgets,
                    index,
                  })
                }
                onDragEnter={() => onDragEnterAvailable(index)}
              >
                <Accordion defaultExpanded>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>{headerAvailable(accordionName)}</AccordionSummary>
                  <AccordionDetails>
                    {availableContent(object[accordionName]?.widgets, accordionName, index)}
                  </AccordionDetails>
                </Accordion>
              </div>
            );
          })}
        </div>
      </div>
      {/* <div className={css.availableOptionContainer}>
        <div className={css.optionStyle}>
          <IconComponent
            name="ArrowsUp"
            height="16px"
            width="16px"
          />
        </div>
        <div className={css.optionStyle}>
          <IconComponent
            name="arrowDown"
            height="16px"
            width="16px"
          />
        </div>
        <div className={css.optionStyle}>
          <IconComponent
            name="BackwardArrow"
            height="16px"
            width="16px"
          />
        </div>
        <div className={css.optionStyle}>
          <IconComponent
            name="ForwardArrow"
            height="16px"
            width="16px"
          />
        </div>
        <div className={css.optionStyle}>
          <IconComponent
            name="BackwardArrow"
            height="16px"
            width="16px"
          />
          <IconComponent
            name="BackwardArrow"
            height="16px"
            width="16px"
          />
        </div>
        <div className={css.optionStyle}>
          <IconComponent
            name="ForwardArrow"
            height="16px"
            width="16px"
          />
          <IconComponent
            name="ForwardArrow"
            height="16px"
            width="16px"
          />
        </div>
      </div> */}
      <div className="w-full h-full pt-7 flex flex-col gap-7">
        <div>{t("Added")}</div>
        <div
          className="border-px border-[var(--surface-stroke-gradient-color1)] shadow-[0.25rem_0.25rem_0.9375rem_rgb(65_92_171_/_15%)] rounded-lg overflow-auto h-full px-4"
          {...({ droppable: "true" } as any)}
          onDragOver={onDragOver2}
          onDrop={() => onDropAdded()}
          onDragEnd={onDragEndAdded}
        >
          {props.addedData.map((object: any, index: number) => {
            const accordionName: any = Object.keys(object)[0];
            return (
              <div
                key={index}
                draggable
                onDragStart={(e) =>
                  dragStartAdded(e, {
                    accordionName,
                    itemArray: object[accordionName]?.widgets,
                    index,
                  })
                }
                onDragEnter={() => onDragEnterAdded(index)}
              >
                <Accordion defaultExpanded>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>{headerAdded(accordionName)}</AccordionSummary>
                  <AccordionDetails style={{ height: "100%" }}>
                    {addedContent(object[accordionName]?.widgets, accordionName, index)}
                  </AccordionDetails>
                </Accordion>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default DesignViewerLayoutSettingComponent;
